const urlPrefiks = import.meta.env.BASE_URL;

export const API_URLS = {
    konto: `${urlPrefiks}/fpgrunndata/api/konto`,
} as const;
